import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default {
    name: "PrintLabel",
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        getAllBins: (context , payload)=>{
            if(!payload) {
                payload = '021'
            }
            return axios.get(`${wareHouseTomcatApiC}bins/getAll/${payload}`)
                .then(({data})=>data)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getPrinters: (context)=>{
            return axios.get(`http://localhost:9090/print/getPrinter`)
                .then(({data})=>data)
                .catch(err=>errorHandler.tomcatError(err))
        },
        printLabel: (context , {payload, printer})=>{
            return axios.post(`http://localhost:9090/print/label?Printer=${printer}`,payload)
                .catch(err=>errorHandler.tomcatError(err))
        },
    }
}
